import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  ReferenceLine,
} from "recharts";

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const value = payload[0].value;
    const color = value >= 0 ? "#00ff00" : "#ff0000"; // Green for positive, red for negative

    return (
      <div
        style={{
          background: "#1a1a1a",
          padding: "8px 12px",
          borderRadius: "8px",
          border: `1px solid ${color}`,
          color: color,
        }}
      >
        <p style={{ margin: 0 }}>
          {value >= 0 ? (
            <>
              Profite: <strong>{value.toFixed(2)}</strong>
            </>
          ) : (
            <>
              Loss: <strong>{value.toFixed(2)}</strong>
            </>
          )}
        </p>
      </div>
    );
  }
  return null;
};

const data = [
  { date: "Jan", equity: 0 },
  { date: "Feb", equity: 500 },
  { date: "Mar", equity: 750 },
  { date: "Apr", equity: 1000 },
  { date: "May", equity: -1000 },
  { date: "Jun", equity: -750 },
  { date: "Jul", equity: -500 },
  { date: "Aug", equity: 100 },
  { date: "Sep", equity: 300 },
  { date: "Oct", equity: 500 },
  { date: "Nov", equity: 800 },
  { date: "Jan", equity: 990 },
  { date: "Feb", equity: -200 },
];

const calculateStrokeSegments = (data) => {
  let segments = [];
  let currentLength = 0;

  for (let i = 1; i < data.length; i++) {
    const prev = data[i - 1];
    const current = data[i];

    // Calculate the segment length
    const segmentLength = Math.sqrt(
      1 + Math.pow(current.equity - prev.equity, 2)
    );
    currentLength += segmentLength;

    // Check if we crossed the zero line
    if (
      (prev.equity >= 0 && current.equity < 0) ||
      (prev.equity < 0 && current.equity >= 0)
    ) {
      // Add a "gap" to the segment
      segments.push(`${currentLength}, 5`);
      currentLength = 0;
    }
  }

  segments.push(`${currentLength}, 10000`); // Ensure we extend to the end
  return segments.join(" ");
};

const EquityCurveChart = (props) => {
  const strokeDasharray = calculateStrokeSegments(props.financeChart);

  const calculateProfitLoss = (data) => {
    props.financeChart.map((item) => {
    })
    return props.financeChart.map((item) => ({
      ...item,
      profitOrLoss: item.totalAmountReceived - item.totalBetAmount,
    }));
  };

  const result = calculateProfitLoss(props.financeChart);

  const getStrokeColor = (value) => (value >= 0 ? "#00ff00" : "#ff0000");

  return (
    <div style={{ width: "100%", height: 300 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={result}
          margin={{ top: 10, right: 10, left: 10, bottom: 10 }}
        >
          <Tooltip content={<CustomTooltip />} cursor={false} />
          <ReferenceLine y={0} stroke="#fff" />
          {/* <Line
            type="monotone"
            dataKey="equity"
            stroke="#ff0000"
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 4 }}
          /> */}
          {/* <Line
            type="monotone"
            dataKey="equity"
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 4 }}
            isAnimationActive={true}
            strokeDasharray="3 3"
            // stroke={data.map((entry) => {
            //     console.log('----',getStrokeColor(entry.equity))
            //     getStrokeColor(entry.equity)
            // }).join(",")}
            stroke={data.map((entry) => getStrokeColor(entry.equity)).join(",")}
          /> */}

          {/* Base invisible line for continuity */}
          {/* <Line
            type="monotone"
            dataKey="equity"
            stroke="transparent"
            strokeWidth={2}
            dot={false}
          /> */}

          {/* Positive Segment Line */}
          <Line
            type="monotone"
            dataKey="profitOrLoss"
            stroke="#00ff00"
            strokeWidth={2}
            strokeDasharray={strokeDasharray}
            dot={false}
            isAnimationActive={true}
          />

          {/* Negative Segment Line */}
          <Line
            type="monotone"
            dataKey="profitOrLoss"
            stroke="#ff0000"
            strokeWidth={2}
            strokeDasharray={strokeDasharray}
            dot={false}
            isAnimationActive={true}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default EquityCurveChart;
